import styled from 'styled-components';

import {
  colorGrey200,
  colorPrimary50,
  colorPrimary400,
  colorWhite,
} from '@/styleUtils';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 12px;

  svg {
    display: none;
  }

  &[data-is-checked='true'] {
    background: ${colorPrimary50};

    div:first-of-type {
      background: ${colorPrimary400};
      border: none;
    }

    svg {
      width: 13px;
      height: 13px;
      padding: 3px 0 0 2px;
      display: block;
    }
  }
`;

export const Checkbox = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid ${colorGrey200};
  border-radius: 2px;
  flex-shrink: 0;
  color: ${colorWhite};
`;

export const Label = styled.span`
  cursor: pointer;
  display: block;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  margin: 0;
  overflow: hidden;
  padding: 16px 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;

  input:checked + & {
    background-color: ${colorPrimary50};
    position: relative;

    &::after {
      content: '';
      position: absolute;
      display: block;
      height: 9px;
      right: 16px;
      top: 50%;
      transform: rotate(45deg) translateY(-50%);
      transform-origin: right center;
      width: 5px;
      border-color: rgb(35, 156, 19);
      border-style: solid;
      border-width: 0 2px 2px 0;
    }
  }
`;
